import { c as _c } from "react/compiler-runtime";
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { SALES_FUNNELS_API } from 'modules/courses/courses/api/sales-funnels-api';
import { SalesFunnelInterface } from 'modules/courses/courses/types/sales-funnel-interface';
export function useSalesFunnels() {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return SALES_FUNNELS_API;
      }
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSWR(t0, baseFetcher);
}